import { ImportExportDevLogSummary, ScopeLogSummary } from 'src/stores/dev-logs-store';
import DataStoreMock from './base/data-store';
import { Query } from 'src/core/stores/data-store';
import { ImportExportDevLogsMockData, ScopeLogsMockData } from '../data-sources/dev-logs';

export class ImportExportDevLogsStoreMock extends DataStoreMock<ImportExportDevLogSummary> {
  constructor(baseUrl: string) {
    super(`${baseUrl}export-import/api/logs`);
  }

  public async load(_query: Partial<Query>) {
    this._state.set({
      isBusy: false,
      items: ImportExportDevLogsMockData,
      count: ImportExportDevLogsMockData.length,
    });
    return true;
  }
}

export class ScopeLogsStoreMock extends DataStoreMock<ScopeLogSummary> {
  constructor(baseUrl: string) {
    super(`${baseUrl}/scope-logs`);
  }

  public async load(_query: Partial<Query>) {
    this._state.set({
      isBusy: false,
      items: ScopeLogsMockData,
      count: ScopeLogsMockData.length,
    });
    return true;
  }
}
